import areArrayOfIdsEqual from '$utils/areArrayOfIdsEqual';
import isArrayEmpty from './isArrayEmpty';

const checkSaveDisabled = ({ selectedAssignments, mappedAssignments }) => {
  // assessment item not mapped (undefined or empty)
  // disable save button if no item is selected
  if (isArrayEmpty(mappedAssignments)) {
    return isArrayEmpty(selectedAssignments);
  }

  // assessment item is already mapped
  return areArrayOfIdsEqual(selectedAssignments, mappedAssignments);
};

export default checkSaveDisabled;
